import { saveAs } from 'file-saver';
import moment from 'moment';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
import { withTranslation } from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionButton from '../components/ActionButton';
import { ActionLink } from '../components/ActionLink';
import CustomDialog from '../components/CustomDialog';
import { CustomMessages } from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import YesNoDialog from '../components/YesNoDialog';
import InputCalendarRangeComponent from '../components/inputs/InputCalendarRangeComponent';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputMultiCheckboxComponent from '../components/inputs/InputMultiCheckboxComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import ReportsService from '../services/ReportsService';

class ReportListContainer extends BaseListContainer {
    constructor(props) {
        super(props);
        this.service = new ReportsService();
        this.state = {
            activeIndex: 0,
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            selectedAllColumns: false,
            criteria: this.getCleanSearchCriteria(),
            showDialog: false,
            showEditTemplateDialog: false,
            showDetailsTemplateDialog: false,
            showSecondDialog: false,
            template: '',
            templatesList: [],
            templatesListDetails: [],
            reportFromTemplate: false,
            element: {
                dateFrom: undefined,
                dateTo: undefined,
                columns: [],
                format: undefined,
                saveAsTemplate: false,
                templateName: '',
            },
            columnsOptions: [],
            formatOptions: [
                { value: 'XLSX', label: 'XLSX' },
                { value: 'CSV', label: 'CSV' },
                { value: 'ODS', label: 'ODS' },
            ],
            generatedList: {
                content: [],
                totalElements: 0,
            },
            tempalateList: {
                content: [],
                totalElements: 0,
            },
            removeConfirmationVisible: false,
        };
        this.onRowReorder = this.onRowReorder.bind(this);
        this.dialogRef = createRef();
        this.handleTabChange = this.handleTabChange.bind(this);
       // this.actionTemplate2 = this.actionTemplate2.bind(this);
    }

    initializeFromBackend() {
        const { t } = this.props;
        this.service
            .getTransactionReportAvailableColumns()
            .then((res) => {
                let columnsOptions = [];
                res.forEach((el) => columnsOptions.push({ value: el.columnName, label: t(`reports.reportsColumns.${el.columnName}`) }));
                this.setState({ columnsOptions });
            })
            .catch(() => {
                this.setState({ columnsOptions: [] });
                this.showErrorMessage(t('error.transactionReportAvailableColumnListError'));
            });

       this.getTemplateList();
       this.getTemplateListWithDetails();
    }

    getTemplateList(){
        this.service
        .getReportTemplateList()
        .then((res) => {
            this.setState({ templatesList: res })
        })
        .catch(() => {
            this.setState({ templatesList: [] });
            this.showErrorMessage("Blad podczas pobierania szablonow raportow");
        });
    }

    getTemplateListWithDetails(){
        this.service
        .getReportTemplateListDetails()
        .then((res) => {
            this.setState({ templatesListDetails: res })
        })
        .catch(() => {
            this.setState({ templatesListDetails: [] });
            this.showErrorMessage("Blad podczas pobierania szablonow raportow");
        });
    }

    updateSearchCriteria(criteria) {
        return {
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    updateListElements(list) {
        return list;
    }

    getDataKey() {
        return 'id';
    }

    getCriteriaName() {
        return 'report-list-sc';
    }

    getContainerListName() {
        return 'report-list-container';
    }

    getListTitle() {
        return 'transaction.listTitle';
    }
    onAfterGetList(res) {
        if (this.props.onAfterGetList) {
            this.props.onAfterGetList(res);
        }
        //   this.props.unblockUi();
    }
    handleOnSelectionChange(e) {
        this.setState({
            selectedList: e.value,
            selectAll: e.value.length === this.getTotalElements()
        });
    }
    getList() {
        const { criteria } = this.state;
        this.service
            .getList(criteria)
            .then((res) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            generatedList: {
                                content: this.updateListElements(res.content),
                                totalElements: res.totalElements,
                            },
                            // templateList: {
                            //     content: this.updateListElements(res.templateList?.content),
                            //     totalElements: res.templateList?.totalElements,
                            // },
                            loading: false,
                            // list: this.updateListElements(res.generat?.content),
                            size: res.totalElements,
                        },
                        () => this.onAfterGetList(res)
                    );
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            generatedList: { content: [], totalElements: 0 },

                            loading: false,
                        },
                        () => {
                            this.afterGetListError();
                        }
                    );
                }
            });

    }

    readColumnsFromTemplate(col) {
        const { columnsOptions } = this.state;
        let orderedCheckedColumns = [];
        col.forEach((el) => {
            let elementToAdd = columnsOptions.filter(co => co.value === el)[0];
            orderedCheckedColumns.push(elementToAdd);
        })
        return orderedCheckedColumns;
    }

    getSingleTemplateData(template) {
        this.service
            .getTemplateData(template.id)
            .then((res) => {
                let allCheckboxSelected = false;
                if(res.columns.length === this.state.columnsOptions.length){
                    allCheckboxSelected = true;
                
                }
                this.setState({
                    selectedAllColumns: allCheckboxSelected,
                    element: {
                        id: res.id,
                        dateFrom: undefined,
                        dateTo: undefined,
                        columns: this.readColumnsFromTemplate(res.columns),
                        saveAsTemplate: false,
                        templateName: res.templateName,
                        format: res.format

                    }
                })
            })
            .catch(() => {
                this.setState({ templatesList: [] });
                this.showErrorMessage("Blad podczas pobierania szablonow raportow");
            });
    }


    getCleanSearchCriteria() {
        return {
            firstResult: 0,
            maxResults: 10,
            sortField: 'genDate',
            sortAsc: false,
        };
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    prepareColumns() {
        const { t } = this.props;
        return [
            {
                field: 'genDate',
                header: t('reports.reportGenDate'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'genDate', 'DD-MM-YYYY'),
            },
            { field: 'fileName', header: t('reports.reportName'), sortable: true },
        ];
    }

    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
                selectAll: false,
                selectedList: [],
            }
        );
    }

    actionGenerate(e, rowData){
        //e.preventDefault();
        //this.generateReportFromTemplate(rowData.id);
        //this.getCleanElement();
        this.getSingleTemplateData(rowData);
        this.setState({ showDialog: true, showSecondDialog: false, reportFromTemplate: true });
    }
    actionEdit(e, rowData){
        //e.preventDefault();
        //this.getCleanElement();
        this.getSingleTemplateData(rowData);
        this.setState({ showDialog: true, showSecondDialog: false, showEditTemplateDialog: true });
    }


    dateTemplate(field, format, rowData) {
        if (rowData[field] && moment(rowData[field]).isValid()) {
            return moment(rowData[field]).format(format);
        } else {
            return '';
        }
    }

    prepareHeaderItems() {
        return []; 
    }

    renderPrintButton() {
        const {t} = this.props;
        return (
            <ActionLink
            label={t('details.download')}
            handleClick={(e) => {
                e.preventDefault();
                this.downloadReports();
            }}
            variant='blue report-download-link'
            iconSvg='ico_download_link_icon'
            iconSide='right'
            iconColor='white'
            disabled={this.state.activeIndex !== 0 || !this.state.selectedList || this.state.selectedList.length < 1 || !this.isUserHasPermission('PERMISSION_EDIT_REPORTS')}
        /> 
        );
    }

    getCleanElement() {
        this.setState({
            selectedAllColumns: false,
            template: undefined,
            element: {
                dateFrom: undefined,
                dateTo: undefined,
                columns: [],
                saveAsTemplate: false,
                templateName: '',
            },
        });
    }

    refreshTable() {
        this.getList();
        this.getTemplateList();
        this.getTemplateListWithDetails();
    }

    generateReport(element) {
        const { t } = this.props;
        this.blockUi();
        this.service
            .generateReport(element)
            .then((res) => {
                if(this.state.element.saveAsTemplate === true){
                    if(res.reportGenerationError === null){
                        this.showSuccessMessage(t('reports.generateSuccess'));
                    }
                    if(res.templateCreationError === null){
                        this.showSuccessMessage(t('report-template.reportTemplateCreateSuccess')); 
                    }
                    if(res.reportGenerationError !== null){
                        this.showErrorMessage(t('error.reportsGenerateError'));
                    }
                    if(res.templateCreationError !== null){
                        this.showErrorMessage(t('error.reportTemplateCreateError'));
                    }
                } else {
                    if(res.reportGenerationError === null){
                        this.showSuccessMessage(t('reports.generateSuccess'));
                    }
                    else if(res.reportGenerationError !== null){
                        this.showErrorMessage(t('error.reportsGenerateError'));
                    }
                }
               
                this.setState({ showDialog: false, showSecondDialog: false , showEditTemplateDialog: false, reportFromTemplate: false,showDetailsTemplateDialog: false});
                this.refreshTable();
                this.unblockUi();
            })
            .catch(() => {
                this.setState({ showDialog: false, showSecondDialog: false, showEditTemplateDialog: false, reportFromTemplate: false,showDetailsTemplateDialog: false});
                this.showErrorMessage(t('error.reportsGenerateError'));
                this.unblockUi();
            });
            this.refreshTable();
    }

    editTemplateData(element){
        const {t} = this.props;
        this.service
        .editTemplate(element)
        .then(() => {
            this.setState({ showDialog: false, showSecondDialog: false, showEditTemplateDialog: false, reportFromTemplate: false,showDetailsTemplateDialog: false });
            //this.getTemplateList();
            this.refreshTable();
            this.unblockUi();
            this.showSuccessMessage(t('report-template.reportTemplateUpdateSuccess')); 
        })
        .catch(() => {
            this.setState({ showDialog: false, showSecondDialog: false, showEditTemplateDialog: false, reportFromTemplate: false,showDetailsTemplateDialog: false });
            this.showErrorMessage(t('error.reportTemplateEditError'));
            this.unblockUi();
        });
    }

    removeTemplate(elementId){
        const {t} = this.props;
        this.service
        .removeTemplate(elementId)
        .then(() => {
            this.setState({ showDialog: false, showSecondDialog: false, showEditTemplateDialog: false , removeConfirmationVisible: false, toRemove: undefined});
            //this.getTemplateList();
            this.refreshTable();
            this.unblockUi();
            this.showSuccessMessage(t('report-template.reportTemplateDeleteSuccess')); 
        })
        .catch((err) => {
            this.setState({ showDialog: false, showSecondDialog: false, showEditTemplateDialog: false, removeConfirmationVisible: false, toRemove: undefined });
            this.showErrorMessage(t('error.reportTemplateRemoveError'));
            this.unblockUi();
        });
    }

    showConfirmationRemoveTemplateDialog(a, element) {
        this.setState({removeConfirmationVisible: true, toRemove: element.id});
    }

    generateReportFromTemplate(template) {
        this.getSingleTemplateData(template);
        this.generateReport(this.state.element);
    }

    downloadReports() {
        const { t } = this.props;
        const { selectedList } = this.state;
        if (selectedList && selectedList.length > 0) {
            let reportIds = [];
            selectedList.map((el) => reportIds.push(el.id));
            this.service.downloadReports(reportIds).then((response) => saveAs(response, t('reports.fileName')));
        }
    }

    onRowReorder(e) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                columns: e.value,
            },
        }));
    }

    validateTemplateName(){
        const { t } = this.props;
        const {id, templateName} = this.state.element;
        this.service.validateTemplateName(templateName, id)
        .then((res) => {
            if(res === true){
                this.setState({ showSecondDialog: true });
            } else{
                this.showErrorMessage(t('report-template.incorrectName')); 
            }
        })
        .catch((err) => {
            this.showErrorMessage(t('report-template.incorrectName')); 
        });

    }

    handleValidForm() {
        this.unblockUi();
        if (this.state.reportFromTemplate !== true) {
            if((this.state?.element?.saveAsTemplate === true && this.state.element.templateName !== null && this.state.element.templateName !== undefined ) || this.state.showEditTemplateDialog === true){
               this.validateTemplateName();             
            } else if(this.state?.element?.saveAsTemplate === false){
                
                this.setState({ showSecondDialog: true });
            } 
        } 

        this.scrollToTopfDialog();
    }

    scrollToTopfDialog() {
        if (
            this.props.mainRef !== undefined &&
            this.props.mainRef.current !== undefined &&
            ReactDOM.findDOMNode(this.props.mainRef.current) !== undefined &&
            ReactDOM.findDOMNode(this.props.mainRef.current) !== null
        ) {
            ReactDOM.findDOMNode(this.props.mainRef.current).scrollIntoView();
        } else if (this !== undefined && ReactDOM.findDOMNode(this) !== undefined && ReactDOM.findDOMNode(this) !== null) {
            ReactDOM.findDOMNode(this).scrollIntoView();
        } else {
            console.log('scrollToTop ', this, ReactDOM.findDOMNode(this));
        }
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
            return false;
        }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
            return false;
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
            return true;
        }
    }

    renderDialog() {
        const { t } = this.props;
        const { template, templatesList, columnsOptions, formatOptions } = this.state;
        const { dateFrom, dateTo, columns, format } = this.state.element;
        return (
            <div className=''>
                {!this.state.showSecondDialog ? (
                    <div>
                        <div className='row' style={{ paddingBottom: '15px' }}>
                                <InputTextComponent
                                    id='templateName'
                                    name='templateName'
                                    label={t('order-card.draftName')}
                                    colClass='col-md-10 col-sm-10'
                                    value={this.state.element.templateName}
                                    placeholder={''}
                                    viewMode={this.state.showDetailsTemplateDialog === true ? 'VIEW' : 'EDIT'}
                                    validator={this.validator}
                                    validators='required'
                                    onChange={this.handleChange}
                                    rendered={this.state?.showDetailsTemplateDialog === true || this.state.showEditTemplateDialog === true }
                                    showLabel={true}
                                /> 
                            <InputDropdownComponent
                                id='format-dropdown-template'
                                name='template'
                                label={"Wybierz szablon z listy"}
                                colClass='col-xl-10 col-lg-10 col-sm-10'
                                value={template}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='not_required'
                                options={templatesList}
                                onChange={this.handleChange}
                                optionLabel='name'
                                dataKey='id'
                                stateField=''
                                onAfterStateChange={(e) => {
                                    if (this.state.template !== undefined && this.state.template !== "") {
                                        this.getSingleTemplateData(this.state.template);
                                    }
                                    else {
                                        this.setState({element: {templateName : undefined}})
                                    }
                                }}
                                rendered={this.state.reportFromTemplate === false && this.state.showEditTemplateDialog !== true && this.state.showDetailsTemplateDialog !== true}
                                showClear
                            />
                            <InputDropdownComponent
                                id='format-dropdown'
                                name='format'
                                label={t('reports.format')}
                                colClass='col-xl-10 col-lg-10 col-sm-10'
                                value={format}
                                viewMode={'NEW'}
                                validator={this.validator}
                                validators='required'
                                options={formatOptions}
                                onChange={this.handleChange}
                                optionLabel='label'
                                dataKey='value'
                                enumMode
                                disabled={this.state.reportFromTemplate || this.state.showDetailsTemplateDialog === true}
                            />

                            <InputCalendarRangeComponent
                                id='date'
                                idFrom='dateFrom'
                                idTo='dateTo'
                                name='date'
                                nameFrom='dateFrom'
                                nameTo='dateTo'
                                label={t('transaction.transactionDate')}
                                labelFrom=''
                                labelTo=''
                                colClass='col-xl-10 col-lg-10 col-sm-10 date-selection'
                                from={dateFrom}
                                to={dateTo}
                                onChange={this.handleChange}
                                validator={this.validator}
                                validatorsTo={`required|date|date_format:DD-MM-YYYY,dd-mm-rrrr|max_date_period:${moment(dateFrom).format(
                                    'YYYY-MM-DD'
                                )},12,M,day,${t('reports.datePeriodGt', { count: 12 })}`}
                                showButtonBar
                                sharedLabel
                                renderDash
                                placeholderFrom={t('cards.from')}
                                placeholderTo={t('cards.to')}
                                inputsClassName='col-6'
                                viewMode='NEW'
                                showIcon
                                readOnlyInput={true}
                                rendered={this.state?.showDetailsTemplateDialog !== true && this.state.showEditTemplateDialog !== true }
                            />
                        </div>
                        <InputCheckboxComponent
                            id={'selectedAllColumns'}
                            name={'selectedAllColumns'}
                            label={t('reports.reportsColumns.all')}
                            labelOnRight
                            value={this.state.selectedAllColumns}
                            validator={this.validator}
                            onChange={this.handleChange}
                            viewMode={this.state.reportFromTemplate === false ? 'EDIT' : 'VIEW'}
                            validators='not_required'
                            colClass='col-12 columns-checkboxes'
                            stateField=''
                            onAfterStateChange={() => {
                                if (this.state.selectedAllColumns) {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            columns: columnsOptions,
                                        },
                                    }));
                                } else {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            columns: [],
                                        },
                                    }));
                                }
                            }}
                            rendered={this.state.reportFromTemplate === false && this.state.showDetailsTemplateDialog === false}
                        />
                        {this.state.reportFromTemplate === true || this.state.showDetailsTemplateDialog === true ?
                            <div className='report-template-columns-chosen'>
                                <span className='label'> Wybrane kolumny</span>

                                <div className='columns'>{columns.map(c =>
                                (
                                    <span>&nbsp;{t(`reports.reportsColumns.${c.value}`)} </span>))} </div>
                            </div>

                            : null

                        }
                        <InputMultiCheckboxComponent
                            colClass='col-12 columns-checkboxes'
                            id='columns'
                            label='Wybrane kolumny'
                            showLabel={this.state.reportFromTemplate === true ? true : false}
                            name='columns'
                            onChange={this.handleChange}
                            validator={this.validator}
                            validators='multicheckbox_one_element_required'
                            options={columnsOptions}
                            value={columns}
                            valueKey='value'
                            valueLabel={'label'}
                            itemColClass={'col-12'}
                            viewMode={'NEW'}
                            labelOnRight
                            onAfterStateChange={() => {
                                if (this.state.selectedAllColumns && this.state.element.columns.length === columnsOptions.length) {
                                    this.setState({ selectedAllColumns: true });
                                } else {
                                    this.setState({ selectedAllColumns: false });
                                }
                            }}
                            rendered={this.state.reportFromTemplate === false && this.state.showDetailsTemplateDialog === false}
                        />

                        {((this.state.template === undefined || this.state.template === "") && this.state.reportFromTemplate !== true && this.state?.showDetailsTemplateDialog !== true && this.state.showEditTemplateDialog !== true) ?
                            <div>
                                {this.isUserHasPermission('PERMISSION_EDIT_REPORTS') ? 
                                <div className='report-save-as-template-button'>
                                <hr id='line-separator' />
                                <InputCheckboxComponent
                                    id={'saveAsTemplate'}
                                    name={'saveAsTemplate'}
                                    label={"Zapisz jako szablon"}
                                    labelOnRight
                                    value={this.state.element.saveAsTemplate}
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={'EDIT'}
                                    validators='not_required'
                                    colClass='col-6 '
                                />
                            </div> : null}
                                

                                <InputTextComponent
                                    id='templateName'
                                    name='templateName'
                                    label={t('order-card.draftName')}
                                    colClass='col-md-10 col-sm-10'
                                    value={this.state.element.templateName}
                                    placeholder={t('order-fuel.nameYourDraft')}
                                    viewMode={'EDIT'}
                                    validator={this.validator}
                                    validators='required'
                                    onChange={this.handleChange}
                                    rendered={!!this.state?.element?.saveAsTemplate}
                                    showLabel={false}
                                />   </div> : null
                        }

                    </div>
                ) : (
                    <DataTable
                        id='dataTable'
                        key='data-table'
                        emptyMessage={this.translate('reports.noColumnsSelected')}
                        className='p-datatable-responsive'
                        responsive
                        breakpoint='0px'
                        value={columns}
                        sortOrder={-1}
                        rows={columns.length}
                        lazy={this.props.lazy}
                        onPage={this.handlePage}
                        onSort={this.handleSort}
                        expandedRows={this.state.expandedRows}
                        onRowToggle={this.handleOnRowToggle}
                        onRowExpand={this.handleOnRowExpand}
                        onRowCollapse={this.handleOnRowCollapse}
                        rowExpansionTemplate={this.rowExpansionTemplate}
                        rowClassName={this.props.rowClassName}
                        reorderableColumns
                        onRowReorder={this.onRowReorder}
                    >
                        <Column rowReorder />
                        <Column
                            field='value'
                            header={''}
                            body={(el) => {
                                return el.label;
                            }}
                        />
                    </DataTable>
                )}
                <div className='button-col'>
                    <ActionButton
                        label={t('reports.cancel')}
                        handleClick={(e) => {
                            e.preventDefault();
                            this.getCleanElement();
                            this.validator.hideMessages();
                            this.setState({ showDialog: false, showSecondDialog: false, showEditTemplateDialog: false, showDetailsTemplateDialog: false, reportFromTemplate: false });
                        }}
                        variant='white'
                    />
                    <ActionButton
                        label={this.renderBottomButtonLabel() }
                            
                        handleClick={(e) => {
                            e.preventDefault();
                            if (this.state.showSecondDialog) {
                                if(this.state.showEditTemplateDialog === true){
                                    if (this.handleFormSubmit() === false) {
                                        this.editTemplateData(this.state.element);
                                        this.validator.hideMessages();
    
                                    } else {
                                        this.handleFormSubmit()
                                    }
                                }
                                else {
                                    this.generateReport(this.state.element);
                                    this.validator.hideMessages();
                                }
                            }
                            else if (this.state.reportFromTemplate === true) {
                                if (this.handleFormSubmit() === false) {
                                    this.generateReport(this.state.element);
                                    this.validator.hideMessages();

                                } else {
                                    this.handleFormSubmit();
                                }
                            }
                            else if(this.state.showEditTemplateDialog === true){
                                if (this.handleFormSubmit() !== false) {
                                    this.handleFormSubmit();

                                } 
                            }
                            else {
                                this.handleFormSubmit();
                                // this.setState({showSecondDialog: true});
                            }
                        }}
                        variant='blue'
                        rendered={this.state.showDetailsTemplateDialog !== true}
                    />
                </div>
            </div>
        );
    }

    renderFilter() { }
    
    renderDialogHeader(){
        const {t} = this.props;
        if(this.state.showEditTemplateDialog === true){
          return  <label>{ t('report-template.editHeader') }</label> 
            }
           else if(this.state.showDetailsTemplateDialog === true){
             return   <label>{ t('report-template.detailsHeader') }</label> 
                }
            else if( this.state.reportFromTemplate === true){
             return  <div>
                <div className='generate-report-from-template-header'>{this.state.element.templateName }</div>
                <label>{t('report-template.fillDateRange')}</label>
             </div> 
            }
            else{
             return   <label>{!this.state.showSecondDialog ? t('reports.chooseFields') : t('reports.reorderColumns')}</label>
            }
    }

    renderBottomButtonLabel(){
        const {t} = this.props;
        if(this.state.showEditTemplateDialog === true && this.state.showSecondDialog === true){
            return t('report-template.save')
        }else{
          return  this.state.showSecondDialog || this.state.reportFromTemplate === true ? t('reports.generateReport') : t('reports.next')
        }
        
    }
    handleOnSelectAllChange(e) {
        const selectAll = e.checked;
        if (selectAll && !this.props.lazy) {
            if (this.state.activeIndex === 0) {
                this.setState({
                    selectAll: true,
                    selectedList: this.state.generatedList?.content,
                }); 
            } else {
                    this.setState({
                        selectAll: false,
                        selectedList: []
                    });
                }
            } else {
            this.setState({
                selectAll: false,
                selectedList: [],
                loading: false,
            });
        }
    }

    renderDetails() {
        const { t } = this.props;
        return (
            <div>
                <div className='row generate-report-row'>
                    <div className='col-width-auto list-header'>
                    <ActionButton
                            label={t('reports.generateReport')}
                            handleClick={(e) => {
                                e.preventDefault();
                                this.getCleanElement();
                                this.setState({ showDialog: true, showSecondDialog: false });
                            }}
                            variant='blue'
                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_REPORTS') }
                        />
                    </div>
                    <div className='col-width-auto'>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { t, viewMode } = this.props;
        const { blocking, loading, showDialog } = this.state;
        return (
            <DivContainer colClass='container-fluid reports-container'>
                <BlockUi tag='div' blocking={blocking || loading} loader={this.loader}>
                <YesNoDialog
                                visible={this.state.removeConfirmationVisible}
                                header={t('report-template.removeTemplateDialogHeader')}
                                name='visible'
                                onChange={(type, x, target) => {
                                    if(!!target.value){
                                        this.removeTemplate(this.state.toRemove);
                                    } else {
                                        this.setState({ showDialog: false, showSecondDialog: false, removeConfirmationVisible: false, toRemove: undefined});
                                    }
                                    
                                   // this.hideConfirmationRemoveTemplateDialog(target.value);
                                }}
                                onHide={() => {
                                    this.getCleanElement();
                                    //this.validator.hideMessages();
                            this.setState({ showDialog: false, showSecondDialog: false, removeConfirmationVisible: false, toRemove: undefined});
                                }}
                                noButtonVariant='button cancel-button white'
                                yesButtonVariant='button save-button fullred'
                            >
                                {t('order-card.removeTemplateDialogConfirmation')}
                            </YesNoDialog>
                            {this.renderAddToTrustedDevicesDialog()}
                    <CustomDialog
                        ref={this.dialogRef}
                        name='message-dialog'
                        className='reports-dialog'
                        visible={showDialog}
                        viewMode={viewMode}
                        onHide={() => {
                            this.getCleanElement();
                            this.validator.hideMessages();
                            this.setState({ showDialog: false, showSecondDialog: false, showEditTemplateDialog: false, showDetailsTemplateDialog: false, reportFromTemplate: false });
                        }}
                        modal
                        header={() =>{
                           return this.renderDialogHeader() }
                            }
                    >
                        {this.renderDialog()}
                    </CustomDialog>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                    {this.renderDetails()}
                    {/* {this.renderView()} */}
                    <Card
                        className='list-card card-list-container'
                    // header={this.renderHeader()}
                    >
                        <DivContainer rendered={this.props.phoneNumber === undefined || this.props.phoneNumber === null} colClass='row'>
                            {this.renderFilter()}
                        </DivContainer>
                        <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                        {
                            <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} className='sub-tabview-reports'>
                                <TabPanel header={`${t('reports.generated')} (${this.state.generatedList?.totalElements})`}>
                                   <div className='download-button-row-reports-generated'>{this.renderPrintButton()}</div> 
                                    {this.renderDataTable(
                                        this.prepareColumns(),
                                        this.state.generatedList?.content,
                                        this.state.generatedList?.totalElements
                                    )}
                                </TabPanel>
                                {/* <TabPanel header={`${t('reports.templates')} (${this.state.templatesList?.length !== null && this.state.templatesList?.length !== undefined ? this.state.templatesList?.length : ''})`}>
                                    {this.renderDataTable(
                                        this.prepareTemplateColumns(),
                                        this.state.templatesList,
                                        this.state.templatesList?.length
                                    )}
                                </TabPanel> */}

                                <TabPanel header={`${t('reports.templates')} (${this.state.templatesList?.length !== null && this.state.templatesList?.length !== undefined ? this.state.templatesList?.length : ''})`}>
                                    {
                                        <DivContainer colClass='col-12  reports-template-accordion'>
                            <DivContainer colClass='row'>
                                <Accordion multiple>
                                    {this.state.templatesListDetails && this.state.templatesListDetails.length
                                        ? this.state.templatesListDetails.map((element, index) => {
                                              return (
                                                  <AccordionTab
                                                      header={element.name}
                                                      key={`header-${element.draftName}-${index}`}
                                                  >
                                                      <DivContainer colClass='dashboard'>
                                                          <DivContainer colClass='col-12 dashboard-link-container'>
                                                              <DivContainer colClass=' template-list-col-padding'>
                                                                
                                                               <div colClass='report-template-accordion'>
                                                               <div className='report-template-columns-accordion'>
                                                                    <span className='label'> Format </span>

                                                                    <div className='columns'>
                                                                        <span>&nbsp;{element.format} </span></div>
                                                                </div>
                                                               <div className='report-template-columns-accordion'>
                                                                    <span className='label'> Wybrane kolumny</span>
                                                                   <div className='cols'>
                                                                   { element.columns?.split(",").map((c, indexCol) =>
                                                                    (
                                                                        <label key = {`col-${c}-${indexCol}`} className='label-column'> &nbsp;{t(`reports.reportsColumns.${c}`)} </label>
                                                                       
                                                                        ))}  
                                                                   </div>
                                                                    
                                                                </div>
                                                               
                                                               </div>
                                                                  {/* {this.renderFuelsSummary(element)} */}
                                                              </DivContainer>
                                                              <div className='template-buttons'>
                                                                  <div className='left'>
                                                                      <ActionButton
                                                                          label={t('details.delete')}
                                                                          variant='button cancel-button red'
                                                                          handleClick={(e) => {
                                                                              if (e) {
                                                                                  e.preventDefault();
                                                                              }
                                                                              this.showConfirmationRemoveTemplateDialog(e, element)
                                                                          }}
                                                                          disabled={!this.isUserHasPermission('PERMISSION_EDIT_REPORTS')}
                                                                      />

                                                                      <ActionButton
                                                                          label={t('details.editButton')}
                                                                          variant='editButton white'
                                                                          handleClick={(e) => {
                                                                              if (e) {
                                                                                  e.preventDefault();
                                                                              }
                                                                             this.actionEdit(e, element)
                                                                          }}
                                                                          disabled={!this.isUserHasPermission('PERMISSION_EDIT_REPORTS')}
                                                                      />
                                                                  </div>
                                                                  <div className='right'>
                                                                      <ActionButton
                                                                          label={t('report-template.generateFromTemplate')}
                                                                          variant='editButton blue'
                                                                          handleClick={(e) =>
                                                                            this.actionGenerate(e, element)
                                                                          }
                                                                          disabled={!this.isUserHasPermission('PERMISSION_EDIT_REPORTS')}
                                                                      />
                                                                  </div>
                                                              </div>
                                                          </DivContainer>
                                                      </DivContainer>
                                                  </AccordionTab>
                                              );
                                          })
                                        : null}
                                </Accordion>
                            </DivContainer>
                        </DivContainer>

                                    }
                                </TabPanel>
                            </TabView>
                        }
                    </Card>
                </BlockUi>
            </DivContainer>
        );
    }
}

ReportListContainer.defaultProps = {
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
};

ReportListContainer.propTypes = {};

export default withTranslation()(ReportListContainer);
